import { Modal } from 'components/notifications';
import { PolicyDocumentTypes } from 'pages/policy/document/constants/PolicyDocumentTypes';
import { ViewDocument } from 'pages/policy/shared';
import PropTypes from 'prop-types';
import React from 'react';

export function ViewDocumentModal({
    isOpen,
    onClose,

    documentData = {
        documentName: "",
        documentStorageIdentifier: "",
        documentType: PolicyDocumentTypes.UNSIGNED,
    }
}) {
    documentData = documentData || {
        documentName: "",
        documentStorageIdentifier: null,
        documentType: PolicyDocumentTypes.UNSIGNED,
    };

    return (
        <Modal onClose={onClose} title={documentData.documentName} isOpen={isOpen} size="large" fixedHeight={true} fixedHeightPercentage={70}>
            <ViewDocument
                documentName={documentData.documentName}
                documentStorageIdentifier={documentData.documentStorageIdentifier}
                documentType={documentData.documentType}
                showTitle={false}
            />
        </Modal>
    );
}

ViewDocumentModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    documentData: PropTypes.shape({
        documentName: PropTypes.string,
        documentStorageIdentifier: PropTypes.string,
        documentType: PropTypes.oneOf([PolicyDocumentTypes.SIGNED, PolicyDocumentTypes.UNSIGNED])
    }),
};